import React, { useEffect, useState } from 'react';
import { FiBarChart2 } from 'react-icons/fi';

const ThisMonthSales = () => {
    const [sales, setSales] = useState([]);

    let currentDate = new Date();

    // Get the current month and year as strings
    let monthName = currentDate.toLocaleString('default', { month: 'long' });
    let yearName = currentDate.toLocaleString('default', { year: 'numeric' });
    const month = monthName + " " + yearName
    useEffect(() => {
        fetch(`https://servers.thakurgaonexpress.com/rupkotha/getmonthwisesales`)
            .then(res => res.json())
            .then(data => {
                const filtered = (Array.isArray(data) ? data : []).filter(sale => sale.month === month);
                setSales(filtered[0]);
            }
            )
            .catch(() => setSales(undefined));
    }, [])


    return (
        // <div class="mx-auto w-11/12 bg-coral text-textPrimary rounded-lg overflow-hidden bg-[#E7FCE9] shadow-lg glassmorphism p-5">
        <div class="modern-card p-5">
            <div className='flex justify-between items-center'>
                <div class="flex flex-col justify-center items-center">
                    <div class="text-sm font-semibold mb-2">This Month Sales</div>
                    <p class="text-xl text-textPrimary">৳ {sales?.sales ? (sales?.sales)?.toFixed(2) : 0.00}</p>
                </div>
                <div className="dashboard-stat-card__icon"><FiBarChart2 /></div>
            </div>
        </div>
    );
};

export default ThisMonthSales;
